/**
 * Shared shell for sidebar-driven views (structured like JSX: page > header + body).
 * @param {object} opts
 * @param {string} opts.title - Main heading (plain text)
 * @param {string} [opts.subtitle] - Optional subtitle HTML or text 
 * @param {string} opts.main - Inner HTML for the page body
 * @param {boolean} [opts.wide] - Use wider max-width for grids
 * @param {string} [opts.pageClass] - Optional custom class for the fg-page div
 * @param {string} [opts.topAction] - HTML for button above the title
 */
export function sidebarPage({ title, subtitle = '', main, wide = false, pageClass = '', topAction = '' }) {
    const sub = subtitle
        ? `<p class="fg-page__subtitle">${subtitle}</p>`
        : '';
    const mod = wide ? ' fg-page--wide' : '';
    const hasHeader = Boolean(title || subtitle);
    const header = hasHeader
        ? `
            <header class="fg-page__header">
                ${title ? `<h1 class="fg-page__title">${title}</h1>` : ''}
                ${sub}
            </header>
        `
        : '';
    return `
        <div class="fg-page${mod} ${pageClass}">
            ${topAction ? `<div class="fg-page__top-action-wrap" style="display:flex; justify-content:flex-end; padding-bottom:1rem;">${topAction}</div>` : ''}
            ${header}
            <div class="fg-page__body">${main}</div>
            <footer class="footer">
                <div class="footer-logo">
                    <img src="/images/logo2.png" alt="" class="logo-icon">
                    <span class="logo-text">footballgirl</span>
                </div>
                <p class="footer-tagline">The Home of Female Football</p>
                <p style="margin-top: 1rem; font-size: 0.85rem; display: flex; gap: 15px; justify-content: center;">
                    <a href="#page=returns" style="color: var(--text-secondary); text-decoration: underline;">Returns & Refunds</a>
                    <a href="#page=terms" style="color: var(--text-secondary); text-decoration: underline;">Terms of Service</a>
                </p>
            </footer>
        </div>
    `;
}
